let activeId = '';
let generation = 0;
let revision = null;
export const getWorkspaceSession = () => ({ id: activeId, generation, revision });
export const setWorkspaceSession = (id, { force = false } = {}) => {
  const nextId = id || '';
  if (!force && nextId === activeId) return false;
  activeId = nextId;
  generation += 1;
  revision = null;
  return true;
};
// Reads can lower the baseline when an older response arrives out of order,
// but only a successful write may advance the version of an open form.
export const setWorkspaceRevision = (id, value, replace = false) => {
  if (id !== activeId || value === null || value === undefined || !Number.isSafeInteger(Number(value)) || Number(value) < 0) return;
  revision = revision === null || replace ? Number(value) : Math.min(revision, Number(value));
};
export const isWorkspaceRequest = (url = '') => /^\/(free-plan|transactions|accounts|credit-cards|debts|subscriptions|savings-goals|savings|assets|trips|shared-groups|events|habits|reminders|upcoming-payments|dashboard|analytics|forecast|forecast-profile|categories|budgets|budget|category-budgets|chat|ai|reports|export|exports|fx|_legacy)(\/|\?|$)/.test(url);
